import { Waves, Bed, Utensils, HeartHandshake, Wifi, Coffee, Bath, Mountain, Users, Sparkles } from 'lucide-react';

export const availableAmenities = [
  { id: 'wifi', icon: Wifi, label: 'Free Wi-Fi' },
  { id: 'coffee', icon: Coffee, label: 'Breakfast' },
  { id: 'bath', icon: Bath, label: 'En-suite bath' },
  { id: 'mountain', icon: Mountain, label: 'Ocean view' },
  { id: 'users', icon: Users, label: 'Shared capacity' },
  { id: 'sparkles', icon: Sparkles, label: 'Premium linens' },
];

export let packages = [];


export const includedCategories = [
  {
    title: 'Accommodation',
    icon: Bed,
    items: [
      '7 Days Accommodation',
      'Cleaning & Fresh Towels',
      'Optical Fibre WiFi',
      'Use of TV, Netflix & Instruments'
    ]
  },
  {
    title: 'Activities',
    icon: Waves,
    items: [
      'Daily Guiding (2 sessions)',
      'Free Board & Wetsuit Use',
      '1 Surf Trip (North or South)',
      'Sunrise & Sunset Surf (on request)'
    ]
  },
  {
    title: 'Food & Drinks',
    icon: Utensils,
    items: [
      'Moroccan Breakfast ×7',
      'Lunch on the Beach ×7',
      'Moroccan Dinner ×6 (Sunday Off)',
      'BBQ Saturday'
    ]
  },
  {
    title: 'Services',
    icon: HeartHandshake,
    items: [
      'Airport Pick Up & Drop Off (7 Nights)',
      'Use of Skate & Surf Skate'
    ]
  }
];

export let rooms = [];
export let activities = [];
export let blogs = [];
export let products = [];
export let teamMembers = [];

export const initData = async () => {
  let apiPackages = [];
  let apiRooms = [];
  let apiActivities = [];
  let apiBlogs = [];
  let apiProducts = [];
  let apiTeam = [];

  try {
    const [packagesRes, roomsRes, activitiesRes, blogsRes, productsRes, teamRes] = await Promise.allSettled([
      fetch('/api/packages'),
      fetch('/api/rooms'),
      fetch('/api/activities'),
      fetch('/api/blogs'),
      fetch('/api/products'),
      fetch('/api/team')
    ]);
    
    if (packagesRes.status === 'fulfilled' && packagesRes.value.ok) {
      apiPackages = await packagesRes.value.json();
    }
    
    if (roomsRes.status === 'fulfilled' && roomsRes.value.ok) {
      const rawRooms = await roomsRes.value.json();
      apiRooms = rawRooms.map(room => ({
        ...room,
        amenities: (room.amenities || []).map(a => {
          if (typeof a === 'string') {
            return availableAmenities.find(av => av.id === a) || { id: a, label: a, icon: Wifi };
          }
          return { ...a, icon: a.icon || availableAmenities.find(av => av.label === a.label)?.icon || Wifi };
        })
      }));
    }
    
    if (activitiesRes.status === 'fulfilled' && activitiesRes.value.ok) {
      apiActivities = await activitiesRes.value.json();
    }

    if (blogsRes.status === 'fulfilled' && blogsRes.value.ok) {
      apiBlogs = await blogsRes.value.json();
    }

    if (productsRes.status === 'fulfilled' && productsRes.value.ok) {
      apiProducts = await productsRes.value.json();
    }

    if (teamRes.status === 'fulfilled' && teamRes.value.ok) {
      apiTeam = await teamRes.value.json();
    }
  } catch (error) {
    console.warn("Failed to load initial data from API", error);
  }

  try {
    const localPackages = JSON.parse(localStorage.getItem('mermaids_packages')) || [];
    const combinedPackages = [...localPackages, ...apiPackages];
    if (combinedPackages.length > 0) {
      packages = Array.from(new Map(combinedPackages.map(item => [item.slug || item.id, item])).values());
    }

    const localRooms = JSON.parse(localStorage.getItem('mermaids_rooms')) || [];
    const combinedRooms = [...localRooms, ...apiRooms];
    if (combinedRooms.length > 0) {
      rooms = Array.from(new Map(combinedRooms.map(item => [item.slug || item.id, item])).values());
    }

    const localActivities = JSON.parse(localStorage.getItem('mermaids_activities')) || [];
    const combinedActivities = [...localActivities, ...apiActivities];
    if (combinedActivities.length > 0) {
      activities = Array.from(new Map(combinedActivities.map(item => [item.slug || item.id, item])).values());
    }

    const localBlogs = JSON.parse(localStorage.getItem('mermaids_blogs')) || [];
    const combinedBlogs = [...localBlogs, ...apiBlogs];
    if (combinedBlogs.length > 0) {
      blogs = Array.from(new Map(combinedBlogs.map(item => [item.slug || item.id, item])).values());
    }

    const localProducts = JSON.parse(localStorage.getItem('mermaids_products')) || [];
    const combinedProducts = [...localProducts, ...apiProducts];
    if (combinedProducts.length > 0) {
      products = Array.from(new Map(combinedProducts.map(item => [item.slug || item.id, item])).values());
    }

    if (apiTeam.length > 0) {
      teamMembers = apiTeam;
    }
  } catch (e) {
    console.error("Error syncing local storage:", e);
  }
};


export const schedule = [
  { time: '07:30', title: 'Sunrise Surf', desc: '(if guest wishes)' },
  { time: '09:00', title: 'Moroccan Healthy Breakfast', desc: '' },
  { time: '10:00', title: 'Roadtrip and Surf Spot Checking', desc: '' },
  { time: '12:30', title: 'Lunch at the Beach', desc: '' },
  { time: '13:30', title: 'Another surf or two', desc: 'Or even 3 if you are not beaten' },
  { time: '16:30', title: 'Out of the Surfspot', desc: '' },
  { time: '18:30', title: 'Sunset Restorative Yoga', desc: '(Optional)' },
  { time: '20:00', title: 'Moroccan 3 Course Meal', desc: '(Sunday dinners not Included)' },
  { time: '21:00', title: 'Terrace Chills', desc: 'Music, Society Games, Surf Discussion for the Next Day' },
];


